"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hmacSha256Sign = hmacSha256Sign;
exports.hmacSha256Verify = hmacSha256Verify;
exports.hmacSha512Sign = hmacSha512Sign;
exports.hmacSha512Verify = hmacSha512Verify;

var _browser = require("../lib/browser");

var _helpers = require("../helpers");

async function hmacSha256Sign(key, msg) {
  const result = await (0, _browser.browserHmacSha256Sign)(key, msg);
  return result;
}

async function hmacSha256Verify(key, msg, sig) {
  const expectedSig = await (0, _browser.browserHmacSha256Sign)(key, msg);
  const result = (0, _helpers.isConstantTime)(expectedSig, sig);
  return result;
}

async function hmacSha512Sign(key, msg) {
  const result = await (0, _browser.browserHmacSha512Sign)(key, msg);
  return result;
}

async function hmacSha512Verify(key, msg, sig) {
  const expectedSig = await (0, _browser.browserHmacSha512Sign)(key, msg);
  const result = (0, _helpers.isConstantTime)(expectedSig, sig);
  return result;
}